// ముందే స్టేట్ ఎలా ఉండాలో డిఫైన్ చేయండి
const initialState = {
  loading: true, // మొదట లోడింగ్ ట్రూ ఉండాలి, అప్పుడు మాత్రమే యాప్ సర్వర్ కోసం ఆగుతుంది
  isAuthenticated: false,
  user: null,
};

export const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case "LOGIN_REQUEST":
    case "LOAD_USER_REQUEST":
      return { ...state, loading: true };

    case "LOGIN_SUCCESS":
    case "LOAD_USER_SUCCESS":
      return { loading: false, isAuthenticated: true, user: action.payload };

    case "LOGIN_FAIL":
    case "LOAD_USER_FAIL":
      return {
        loading: false,
        isAuthenticated: false,
        user: null,
        error: action.payload,
      };

    case "LOGOUT_SUCCESS":
      return { loading: false, isAuthenticated: false, user: null };

    default:
      return state;
  }
};
